import { Card, CardHeader, Stack } from '@mui/material'
import { memo } from 'react'

import DisplayBadge from '../membership/DisplayBadge'
import Text from '../shared/text/Text'

const StatusMultipliers = ({ t, symbol, tiers }) => {
  return (
    <Card sx={{ p: 3 }}>
      <CardHeader
        title={t('earn-via.status-multipliers')}
        subheader={t('earn-via.status-multipliers-desc', { symbol })}
        sx={{ p: 0 }}
      />
      <Stack spacing={1} mt={2}>
        {tiers.map(({ id, name, metadata }) => (
          <Stack key={id} direction='row' justifyContent='space-between'>
            <DisplayBadge name={name} id={id} size='xs' direction='row' />
            <Text
              label={t('earn-via.multi', {
                value: metadata?.ugcMultiplier
              })}
            />
          </Stack>
        ))}
      </Stack>
    </Card>
  )
}

export default memo(StatusMultipliers)
